import React, { useState, useEffect } from 'react';
import { useBlissaroIntegration } from '../../hooks/useBlissaroIntegration';
import Popup from '../common/Popup';

// Komponent formularza tworzenia konta
const CreateAccountForm = ({ email, blissaroIntegration, showPopup, tooltipsEnabled }) => {
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleCreateAccount = async () => {
    if (!name.trim()) {
      showPopup({
        title: "Błąd",
        message: "Podaj swoje imię i nazwisko",
        type: 'error',
        size: 'compact'
      });
      return;
    }

    if (password.length < 8) {
      showPopup({
        title: "Błąd",
        message: "Hasło musi mieć minimum 8 znaków",
        type: 'error',
        size: 'compact'
      });
      return;
    }

    if (password !== confirmPassword) {
      showPopup({
        title: "Błąd",
        message: "Hasła nie są identyczne",
        type: 'error',
        size: 'compact'
      });
      return;
    }

    try {
      await blissaroIntegration.registerUser({
        name: name.trim(),
        email,
        password
      });

      showPopup({
        title: "Sukces",
        message: "Konto zostało utworzone pomyślnie! Możesz teraz generować kody QR.",
        type: 'success',
        size: 'compact'
      });
    } catch (error) {
      console.error('Błąd tworzenia konta:', error);
      showPopup({
        title: "Błąd",
        message: error.message || "Nie udało się utworzyć konta",
        type: 'error',
        size: 'compact'
      });
    }
  };

  return (
    <div style={{ 
      padding: 20, 
      backgroundColor: "#f8f9fa", 
      border: "2px solid #e9ecef", 
      borderRadius: "12px",
      marginBottom: 15
    }}>
      <div style={{ display: "flex", alignItems: "center", marginBottom: 15 }}>
        <span style={{ fontSize: "18px", marginRight: "8px" }}>👤</span>
        <strong style={{ fontSize: "16px", color: "#495057" }}>Utwórz konto Blissaro</strong>
      </div>
      
      <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
        <input
          type="text"
          placeholder="Imię i nazwisko"
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ 
            padding: "12px", 
            border: "2px solid #e9ecef", 
            borderRadius: "8px",
            fontSize: "14px",
            transition: "border-color 0.2s ease",
            outline: "none"
          }}
          onFocus={(e) => e.target.style.borderColor = "#667eea"}
          onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
        />
        
        <input
          type="email"
          placeholder="Email"
          value={email}
          disabled
          style={{ 
            padding: "12px", 
            border: "2px solid #e9ecef", 
            borderRadius: "8px",
            fontSize: "14px",
            backgroundColor: "#f8f9fa",
            color: "#6c757d"
          }}
        />
        
        <input
          type="password"
          placeholder="Hasło (minimum 8 znaków)"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{ 
            padding: "12px", 
            border: "2px solid #e9ecef", 
            borderRadius: "8px",
            fontSize: "14px",
            transition: "border-color 0.2s ease",
            outline: "none"
          }}
          onFocus={(e) => e.target.style.borderColor = "#667eea"}
          onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
        />
        
        <input
          type="password"
          placeholder="Powtórz hasło"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          style={{ 
            padding: "12px", 
            border: "2px solid #e9ecef", 
            borderRadius: "8px",
            fontSize: "14px",
            transition: "border-color 0.2s ease",
            outline: "none"
          }}
          onFocus={(e) => e.target.style.borderColor = "#667eea"}
          onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
        />

        <button
          style={{
            background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
            color: "white", 
            border: "none",
            padding: "12px 20px",
            borderRadius: "8px",
            cursor: blissaroIntegration.loading ? "not-allowed" : "pointer",
            fontSize: "14px",
            fontWeight: "600",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
            opacity: blissaroIntegration.loading ? 0.7 : 1,
            transition: "all 0.3s ease",
            boxShadow: "0 2px 10px rgba(40, 167, 69, 0.3)"
          }}
          disabled={blissaroIntegration.loading}
          onClick={handleCreateAccount}
          title={tooltipsEnabled ? "Utwórz nowe konto w Blissaro" : ""}
          onMouseOver={(e) => {
            if (!e.target.disabled) {
              e.target.style.transform = "translateY(-1px)";
              e.target.style.boxShadow = "0 4px 15px rgba(40, 167, 69, 0.4)";
            }
          }}
          onMouseOut={(e) => {
            e.target.style.transform = "translateY(0)";
            e.target.style.boxShadow = "0 2px 10px rgba(40, 167, 69, 0.3)";
          }}
        >
          <span>{blissaroIntegration.loading ? "⏳" : "✨"}</span>
          {blissaroIntegration.loading ? "Tworzenie konta..." : "Utwórz konto"}
        </button>
      </div>
    </div>
  );
};

const BlissaroQRPanel = ({
  backendUrl,
  projectId,
  orderEmail,
  tooltipsEnabled,
  onAddPlaceholderQR, // Nowy prop - funkcja do dodawania placeholder QR na projekt
  onProjectUpdated, // Nowy prop - funkcja wywoływana po aktualizacji projektu
  onManualSave, // Nowy prop - funkcja zapisywania projektu z górrnej belki
  publicKey, // Dodany prop - klucz publiczny potrzebny do sprawdzenia zamówienia
  onEmailUpdated, // Nowy prop - callback do aktualizacji emaila w komponencie nadrzędnym
  publicMode = true // Nowy prop - określa czy to tryb publiczny (true) czy admin (false)
}) => {
  const [isAddingPlaceholder, setIsAddingPlaceholder] = useState(false);
  const [autoCheckCompleted, setAutoCheckCompleted] = useState(false);
  const [showEmailForSavePopup, setShowEmailForSavePopup] = useState(false);
  const [saveEmail, setSaveEmail] = useState("");
  const [savePopupError, setSavePopupError] = useState("");
  const [saveSending, setSaveSending] = useState(false);
  
  // Stan dla popup
  const [popupConfig, setPopupConfig] = useState(null);
  const showPopup = (config) => setPopupConfig(config);
  const hidePopup = () => setPopupConfig(null);
  
  const blissaroIntegration = useBlissaroIntegration(backendUrl, !publicMode); // isAdminMode = !publicMode

  // Automatyczne sprawdzenie konta przy otwarciu (jeśli jest email w zamówieniu)
  useEffect(() => {
    if (orderEmail && !autoCheckCompleted && !blissaroIntegration.checkResult) {
      console.log('[BlissaroQRPanel] Automatyczne sprawdzanie konta dla:', orderEmail);
      blissaroIntegration.checkUserAccount(orderEmail);
      setAutoCheckCompleted(true);
    }
  }, [orderEmail, autoCheckCompleted, blissaroIntegration.checkResult, blissaroIntegration.checkUserAccount]);

  // Obsługa zmiany emaila - resetuj stan i sprawdź ponownie
  useEffect(() => {
    if (orderEmail && autoCheckCompleted) {
      console.log('[BlissaroQRPanel] Email changed, resetting and checking again:', orderEmail);
      blissaroIntegration.resetState();
      setAutoCheckCompleted(false);
      // Następny useEffect wykona sprawdzenie automatycznie
    }
  }, [orderEmail]); // Tylko orderEmail w dependencies, żeby reagować na zmiany

  // Obsługa zapisywania projektu z sprawdzaniem emaila (jak w EditorTopBar)
  const handleSaveProject = async () => {
    if (!publicKey) {
      showPopup({
        title: "Błąd",
        message: "Brak klucza publicznego do sprawdzenia zamówienia.",
        type: 'error',
        size: 'compact'
      });
      return;
    }

    try {
      const cleanedPublicKey = String(publicKey || '').replace(/[^a-zA-Z0-9]/g, '');
      const orderUrl = `${backendUrl}/client/orders/${cleanedPublicKey}`;
      console.log(`[BlissaroQRPanel] handleSaveProject: Fetching order with cleaned key: ${orderUrl}`);
      
      const orderRes = await fetch(orderUrl, {
        credentials: "include"
      });
      
      if (!orderRes.ok) {
        throw new Error("Błąd pobierania zamówienia.");
      }
      
      const orderData = await orderRes.json();
      const currentEmail = orderData.customOrderId || "";
      
      if (currentEmail.trim()) {
        // Email już istnieje - zapisz projekt (sprawdzenie konta jest automatyczne)
        if (onManualSave) {
          onManualSave(false);
          showPopup({
            title: "Sukces",
            message: "Projekt został zapisany!",
            type: 'success',
            size: 'compact'
          });
        }
      } else {
        // Brak emaila - pokaż popup do wprowadzenia
        setShowEmailForSavePopup(true);
        setSaveEmail("");
        setSavePopupError("");
      }
    } catch (err) {
      console.error("Błąd pobierania zamówienia:", err);
      showPopup({
        title: "Błąd",
        message: "Nie udało się sprawdzić stanu zamówienia.",
        type: 'error',
        size: 'compact'
      });
    }
  };

  // Potwierdzenie zapisu z emailem (jak w EditorTopBar)
  const handleConfirmSavePopup = async () => {
    setSavePopupError("");
    if (!saveEmail || !saveEmail.includes("@")) {
      setSavePopupError("Niepoprawny adres e-mail!");
      return;
    }
    
    setSaveSending(true);
    try {
      const cleanedPublicKey = String(publicKey || '').replace(/[^a-zA-Z0-9]/g, '');
      const patchUrl = `${backendUrl}/client/orders/${cleanedPublicKey}/email`;
      const body = { email: saveEmail };
      
      console.log(`[BlissaroQRPanel] handleConfirmSavePopup: Patching email: ${patchUrl}`);
      const patchRes = await fetch(patchUrl, {
        method: "PATCH",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      
      if (!patchRes.ok) {
        throw new Error("Błąd zapisu e-maila w zamówieniu.");
      }
      
      // Zapisz projekt
      if (onManualSave) {
        onManualSave(false);
      }
      
      setShowEmailForSavePopup(false);
      setSaveSending(false);
      
      showPopup({
        title: "Sukces",
        message: "Email został zapisany i projekt zaktualizowany!",
        type: 'success',
        size: 'compact'
      });
      
      // Po zapisaniu sprawdź konto dla nowego emaila
      // Wywołaj callback do nadrzędnego komponentu, żeby zaktualizował orderEmail
      if (onEmailUpdated) {
        onEmailUpdated(saveEmail);
      }
      
      // useEffect automatycznie wykryje zmianę orderEmail i sprawdzi konto
      
    } catch (err) {
      console.error("Błąd zapisu emaila:", err);
      setSavePopupError("Nie udało się zapisać adresu e-mail. Spróbuj ponownie.");
    } finally {
      setSaveSending(false);
    }
  };

  // Obsługa sprawdzenia ponownego po zapisaniu projektu
  const handleCheckAfterSave = () => {
    if (orderEmail) {
      blissaroIntegration.resetState();
      setAutoCheckCompleted(false);
      // Automatyczne sprawdzenie zostanie wykonane przez useEffect
    }
  };

  // Obsługa dodawania placeholder QR
  const handleAddPlaceholderQR = async () => {
    if (!onAddPlaceholderQR) {
      showPopup({
        title: "Błąd",
        message: "Funkcja dodawania placeholder QR nie jest dostępna.",
        type: 'error',
        size: 'compact'
      });
      return;
    }

    setIsAddingPlaceholder(true);
    try {
      // Dodaj placeholder QR jako obrazek na projekt
      await onAddPlaceholderQR();
      
      showPopup({
        title: "Sukces",
        message: "Przykładowy kod QR został dodany na projekt! Możesz go teraz przeciągnąć w odpowiednie miejsce.",
        type: 'success',
        size: 'compact'
      });
    } catch (error) {
      console.error('Błąd dodawania placeholder QR:', error);
      showPopup({
        title: "Błąd",
        message: `Nie udało się dodać placeholder QR: ${error.message}`,
        type: 'error',
        size: 'compact'
      });
    } finally {
      setIsAddingPlaceholder(false);
    }
  };

  return (
    <>
      <div style={{ marginTop: 16, padding: 15, borderRadius: "8px", backgroundColor: "#fff", border: "1px solid #dee2e6" }}>
        <h4 style={{ fontSize: "18px", fontWeight: 600, color: "#343a40", marginBottom: 12, display: "flex", alignItems: "center" }}>
          <span style={{ marginRight: "8px" }}>🎯</span>
          Blissaro - Kody QR dla Gości
        </h4>
        
        {/* Nowoczesny opis Blissaro z gradientem i ikonami */}
        <div style={{ 
          marginBottom: 20, 
          padding: 20, 
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", 
          borderRadius: "12px", 
          color: "white", 
          fontSize: 14, 
          lineHeight: 1.6,
          boxShadow: "0 4px 15px rgba(102, 126, 234, 0.3)"
        }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
            <span style={{ fontSize: "24px", marginRight: "10px" }}>🎯</span>
            <strong style={{ fontSize: "16px" }}>Co to jest Blissaro?</strong>
          </div>
          
          <div style={{ marginBottom: 15 }}>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
              <span style={{ marginRight: "8px" }}>✨</span>
              <span>W pełni darmowa aplikacja do generowania kodów QR</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
              <span style={{ marginRight: "8px" }}>📱</span>
              <span>Goście potwierdzają obecność przez internet</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
              <span style={{ marginRight: "8px" }}>🎉</span>
              <span>To tylko jedna z wielu dostępnych funkcji</span>
            </div>
          </div>

          <div style={{ textAlign: "center", marginTop: 15 }}>
            <a 
              href="https://blissaro.com/" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ 
                color: "white", 
                textDecoration: "none",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                padding: "8px 16px",
                borderRadius: "20px",
                border: "1px solid rgba(255, 255, 255, 0.3)",
                display: "inline-flex",
                alignItems: "center",
                gap: "6px",
                fontSize: "13px",
                fontWeight: "500",
                transition: "all 0.3s ease"
              }}
              onMouseOver={(e) => {
                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
                e.target.style.transform = "translateY(-1px)";
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
                e.target.style.transform = "translateY(0)";
              }}
            >
              <span>🌐</span>
              Przeczytaj więcej na Blissaro
            </a>
          </div>
        </div>

        {/* Informacja o potrzebie założenia konta */}
        <div style={{ 
          marginBottom: 15, 
          padding: 15, 
          backgroundColor: "#e8f4fd", 
          border: "1px solid #bee5eb", 
          borderRadius: "8px", 
          fontSize: 14, 
          lineHeight: 1.5 
        }}>
          <div style={{ display: "flex", alignItems: "center", marginBottom: 8 }}>
            <span style={{ marginRight: "8px", fontSize: "16px" }}>👤</span>
            <strong style={{ color: "#0c5460" }}>Wymagane konto Blissaro</strong>
          </div>
          <span style={{ color: "#0c5460" }}>
            Aby korzystać z kodów QR, musisz założyć darmowe konto na Blissaro. 
            Podaj swój adres email poniżej - sprawdzimy czy masz już konto lub pomożemy je założyć.
          </span>
        </div>

        {/* Komunikaty błędów */}
        {blissaroIntegration.error && (
          <div style={{ 
            marginBottom: 15, 
            padding: 12, 
            backgroundColor: "#f8d7da", 
            border: "1px solid #f5c6cb", 
            borderRadius: "4px", 
            color: "#721c24",
            fontSize: 14
          }}>
            ❌ {blissaroIntegration.error}
          </div>
        )}

        {/* Wynik sprawdzenia konta */}
        {blissaroIntegration.checkResult && (
          <div style={{ 
            marginBottom: 15, 
            padding: 12, 
            backgroundColor: blissaroIntegration.hasUserAccount ? "#d4edda" : "#fff3cd", 
            border: `1px solid ${blissaroIntegration.hasUserAccount ? "#c3e6cb" : "#ffeaa7"}`, 
            borderRadius: "4px", 
            color: blissaroIntegration.hasUserAccount ? "#155724" : "#856404",
            fontSize: 14
          }}>
            {blissaroIntegration.hasUserAccount ? "✅" : "⚠️"} 
            {blissaroIntegration.hasUserAccount 
              ? "Konto w Blissaro jest powiązane z tym projektem."
              : "Brak konta w Blissaro - wypełnij dane poniżej aby je utworzyć"
            }
          </div>
        )}

        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {/* Scenariusz 1: Jest email w zamówieniu - sprawdzamy/tworzymy konto dla tego email */}
          {orderEmail ? (
            <>
              {/* Wyświetlanie adresu email z zamówienia (bez możliwości edycji) */}
              <div style={{ 
                padding: 12, 
                backgroundColor: "#f8f9fa", 
                border: "2px solid #e9ecef", 
                borderRadius: "8px",
                fontSize: "14px",
                display: "flex",
                alignItems: "center",
                gap: "8px"
              }}>
                <span>📧</span>
                <span style={{ color: "#495057" }}>
                  Adres email z zamówienia: <strong>{orderEmail}</strong>
                </span>
              </div>

              {/* Stan sprawdzania konta */}
              {!blissaroIntegration.checkResult && !blissaroIntegration.loading && (
                <div style={{ 
                  padding: 15, 
                  backgroundColor: "#e8f4fd", 
                  border: "1px solid #bee5eb", 
                  borderRadius: "8px", 
                  fontSize: 14 
                }}>
                  <span style={{ color: "#0c5460" }}>
                    Sprawdzimy czy masz już konto w Blissaro dla tego adresu email.
                  </span>
                </div>
              )}

              {/* Ładowanie */}
              {blissaroIntegration.loading && (
                <div style={{ 
                  padding: 15, 
                  backgroundColor: "#fff3cd", 
                  border: "1px solid #ffeaa7", 
                  borderRadius: "8px", 
                  fontSize: 14,
                  display: "flex",
                  alignItems: "center",
                  gap: "8px"
                }}>
                  <span>⏳</span>
                  <span style={{ color: "#856404" }}>Sprawdzanie konta w Blissaro...</span>
                </div>
              )}

              {/* Formularz rejestracji gdy konto nie istnieje */}
              {blissaroIntegration.checkResult && !blissaroIntegration.hasUserAccount && (
                <CreateAccountForm 
                  email={orderEmail}
                  blissaroIntegration={blissaroIntegration}
                  showPopup={showPopup}
                  tooltipsEnabled={tooltipsEnabled}
                />
              )}

              {/* Potwierdzenie istnienia konta */}
              {blissaroIntegration.checkResult && blissaroIntegration.hasUserAccount && (
                <div style={{ 
                  padding: 15, 
                  backgroundColor: "#d4edda", 
                  border: "2px solid #c3e6cb", 
                  borderRadius: "12px",
                  marginBottom: 15
                }}>
                  <div style={{ display: "flex", alignItems: "center", marginBottom: 10 }}>
                    <span style={{ fontSize: "18px", marginRight: "8px" }}>✅</span>
                    <strong style={{ fontSize: "16px", color: "#155724" }}>Konto potwierdzone</strong>
                  </div>
                  <p style={{ margin: 0, color: "#155724", fontSize: "14px" }}>
                    Konto w Blissaro jest powiązane z adresem: <strong>{orderEmail}</strong>
                  </p>
                </div>
              )}
            </>
          ) : (
            /* Scenariusz 2: Brak email w zamówieniu */
            <div style={{ 
              padding: 20, 
              backgroundColor: "#fff3cd", 
              border: "2px solid #ffeaa7", 
              borderRadius: "12px",
              textAlign: "center"
            }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 15 }}>
                <span style={{ fontSize: "24px", marginRight: "10px" }}>📝</span>
                <strong style={{ fontSize: "16px", color: "#856404" }}>
                  {publicMode ? "Wymagane zapisanie projektu" : "Brak emaila klienta"}
                </strong>
              </div>
              
              <p style={{ margin: 0, color: "#856404", fontSize: "14px", marginBottom: 20, lineHeight: 1.5 }}>
                {publicMode ? (
                  <>
                    Aby korzystać z kodów QR Blissaro, musisz najpierw zapisać projekt i podać swój adres email.
                    <br />
                    Po zapisaniu automatycznie sprawdzimy czy masz konto w Blissaro.
                  </>
                ) : (
                  <>
                    Aby korzystać z kodów QR Blissaro, klient musi mieć podany adres email w zamówieniu.
                    <br />
                    Przejdź do szczegółów zamówienia i dodaj email klienta.
                  </>
                )}
              </p>

              {publicMode ? (
                <button
                  style={{
                    background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                    color: "white", 
                    border: "none",
                    padding: "12px 24px",
                    borderRadius: "8px",
                    cursor: (onManualSave && publicKey) ? "pointer" : "not-allowed",
                    fontSize: "14px",
                    fontWeight: "600",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    margin: "0 auto",
                    opacity: (onManualSave && publicKey) ? 1 : 0.5,
                    transition: "all 0.3s ease",
                    boxShadow: "0 2px 10px rgba(40, 167, 69, 0.3)"
                  }}
                  disabled={!onManualSave || !publicKey}
                  onClick={handleSaveProject}
                  title={tooltipsEnabled ? "Zapisz projekt i podaj adres email" : ""}
                  onMouseOver={(e) => {
                    if (!e.target.disabled) {
                      e.target.style.transform = "translateY(-1px)";
                      e.target.style.boxShadow = "0 4px 15px rgba(40, 167, 69, 0.4)";
                    }
                  }}
                  onMouseOut={(e) => {
                    if (!e.target.disabled) {
                      e.target.style.transform = "translateY(0)";
                      e.target.style.boxShadow = "0 2px 10px rgba(40, 167, 69, 0.3)";
                    }
                  }}
                >
                  <span>💾</span>
                  Zapisz projekt
                </button>
              ) : (
                <div style={{ 
                  display: "inline-flex", 
                  alignItems: "center", 
                  gap: "8px",
                  color: "#856404",
                  fontSize: "14px",
                  fontWeight: "500"
                }}>
                  <span>👨‍💼</span>
                  <span>Edytuj email w szczegółach zamówienia</span>
                </div>
              )}
            </div>
          )}

          {/* Przycisk: Wstaw przykładowy kod QR */}
          <button
            style={{
              background: "#6c757d",
              color: "white", 
              border: "none",
              padding: "10px 16px",
              borderRadius: "6px",
              cursor: isAddingPlaceholder ? "not-allowed" : "pointer",
              fontSize: "14px",
              fontWeight: "400",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              opacity: isAddingPlaceholder ? 0.7 : 1
            }}
            disabled={isAddingPlaceholder}
            onClick={handleAddPlaceholderQR}
            title={tooltipsEnabled ? "Wstaw przykładowy kod QR na projekt" : ""}
          >
            <span>{isAddingPlaceholder ? "⏳" : "🖼️"}</span>
            {isAddingPlaceholder ? "Dodawanie..." : "Wstaw przykładowy kod QR"}
          </button>

          <div style={{ marginTop: 8, padding: 10, backgroundColor: "#e7f3ff", borderRadius: "4px", fontSize: 13, color: "#004085" }}>
            💡 <strong>Informacja:</strong> {projectId ? 
              "Tutaj możesz wstawić przykładowy kod QR na projekt. Prawdziwe kody QR zostaną automatycznie wstawione podczas generowania projektu z listą gości w panelu zamówienia." :
              "Brak danych projektu. Odśwież stronę i spróbuj ponownie."
            }
          </div>
        </div>
      </div>

      {/* Popup do wprowadzenia emaila */}
      {showEmailForSavePopup && (
        <div style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 10000
        }}>
          <div style={{
            backgroundColor: "white",
            padding: "30px",
            borderRadius: "12px",
            maxWidth: "400px",
            width: "90%",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)"
          }}>
            <h3 style={{ marginBottom: "20px", color: "#343a40", textAlign: "center" }}>
              📧 Podaj adres email
            </h3>
            <p style={{ marginBottom: "20px", color: "#6c757d", fontSize: "14px", textAlign: "center" }}>
              Aby zapisać projekt, potrzebujemy Twojego adresu email:
            </p>
            
            <input
              type="email"
              placeholder="Twój adres email"
              value={saveEmail}
              onChange={(e) => setSaveEmail(e.target.value)}
              style={{
                width: "100%",
                padding: "12px",
                border: "2px solid #e9ecef",
                borderRadius: "8px",
                fontSize: "14px",
                marginBottom: "15px",
                outline: "none",
                transition: "border-color 0.2s ease"
              }}
              onFocus={(e) => e.target.style.borderColor = "#667eea"}
              onBlur={(e) => e.target.style.borderColor = "#e9ecef"}
            />
            
            {savePopupError && (
              <div style={{
                padding: "10px",
                backgroundColor: "#f8d7da",
                border: "1px solid #f5c6cb",
                borderRadius: "6px",
                color: "#721c24",
                fontSize: "13px",
                marginBottom: "15px"
              }}>
                ❌ {savePopupError}
              </div>
            )}
            
            <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
              <button
                onClick={() => setShowEmailForSavePopup(false)}
                disabled={saveSending}
                style={{
                  padding: "10px 20px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  backgroundColor: "white",
                  color: "#666",
                  cursor: saveSending ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  opacity: saveSending ? 0.5 : 1
                }}
              >
                Anuluj
              </button>
              <button
                onClick={handleConfirmSavePopup}
                disabled={saveSending || !saveEmail}
                style={{
                  padding: "10px 20px",
                  border: "none",
                  borderRadius: "6px",
                  background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                  color: "white",
                  cursor: (saveSending || !saveEmail) ? "not-allowed" : "pointer",
                  fontSize: "14px",
                  fontWeight: "600",
                  opacity: (saveSending || !saveEmail) ? 0.5 : 1,
                  display: "flex",
                  alignItems: "center",
                  gap: "6px"
                }}
              >
                {saveSending ? (
                  <>
                    <span>⏳</span>
                    Zapisywanie...
                  </>
                ) : (
                  <>
                    <span>💾</span>
                    Zapisz
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Popup komunikatów */}
      {popupConfig && (
        <Popup 
          config={popupConfig}
          onClose={hidePopup}
        />
      )}
    </>
  );
};

export default BlissaroQRPanel; 